import { Theme } from '@mui/material';
import { blockedStatesByCountry } from '../data-types/international/internationalConstants';
import { AcceptedCountries } from '../data-types/international/internationalEnums';
import { SuperchargedBetUserInfo } from '../data-types/supercharged-bet/superchargedBetInterfaces';
import { getCitiesByCountry, getNamesByCountry } from '../international/internationalSuperchargedBets';
import { store } from '../state/store';
import { BIG_SCREEN_INTERMEDIATE_SIZE } from '../theme';
import { getRandomNumberBetween } from './general';

export const shouldDisplayFullInfo = (theme: Theme, screenWidth: number) => {
  const { lg, md } = theme.breakpoints.values;

  if (BIG_SCREEN_INTERMEDIATE_SIZE <= screenWidth) {
    return true;
  }

  if (md <= screenWidth && screenWidth < lg) {
    return true;
  }

  return false;
};

const generateSuperchargedUserData = (userLocation: AcceptedCountries): SuperchargedBetUserInfo | null => {
  const names = getNamesByCountry(userLocation);
  const allCitiesFromCountry = getCitiesByCountry(userLocation);
  const blockedStates = blockedStatesByCountry[userLocation] || [];

  if (allCitiesFromCountry && names) {
    const allAllowedCities = allCitiesFromCountry.filter(city => !blockedStates.includes(city.stateCode));

    if (allAllowedCities.length > 0 && names.length > 0) {
      const randomNumberForCity = getRandomNumberBetween(0, allAllowedCities.length - 1);
      const town = allAllowedCities[randomNumberForCity].name;

      const randomNumberForName = getRandomNumberBetween(0, names.length - 1);
      const firstName = names[randomNumberForName];

      return { firstName, town };
    }
  }

  return null;
};

export const tryToGenerateCountrySpecificUserData = (superchargedBetUser: SuperchargedBetUserInfo): SuperchargedBetUserInfo => {
  try {
    const {
      userData: { userLocation },
    } = store.getState();

    if (userLocation && userLocation !== AcceptedCountries.GREAT_BRITAIN) {
      const superchargedData = generateSuperchargedUserData(userLocation);

      if (superchargedData) {
        return superchargedData;
      }
    }

    return superchargedBetUser;
  } catch (e) {
    return superchargedBetUser;
  }
};
